import * as React from 'react';
import { colors } from '../../../index';

const IconAlarm = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 18",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.683 14.713c-1.892-.863-1.964-4.571-1.965-4.665V7.56a5.79 5.79 0 00-3.504-5.33C10.21 1 9.218 0 8 0S5.79 1 5.786 2.23a5.79 5.79 0 00-3.504 5.33v2.488c-.001.094-.073 3.801-1.965 4.665a.509.509 0 00.207.97H5.32c.098.547.354 1.056.745 1.468.52.547 1.207.849 1.935.849s1.415-.302 1.935-.849c.39-.412.647-.92.745-1.468h4.796a.509.509 0 00.207-.97zm-2.492-1.776c.199.61.48 1.222.88 1.731H1.929c.4-.509.681-1.121.88-1.731h10.382zM8 1.015c.551 0 1.017.375 1.163.885a5.661 5.661 0 00-2.326 0c.146-.51.612-.885 1.163-.885zm-4.714 9.036v-2.49c0-2.628 2.115-4.766 4.714-4.766 2.6 0 4.714 2.138 4.714 4.765v2.495c0 .077.012.879.212 1.867H3.074c.2-.989.212-1.793.212-1.87zM8 16.985c-.766 0-1.435-.559-1.65-1.301h3.3c-.215.742-.884 1.3-1.65 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 3.507c-2.16 0-3.917 1.777-3.917 3.96 0 .28.225.508.502.508a.505.505 0 00.502-.508c0-1.624 1.307-2.945 2.913-2.945a.505.505 0 00.502-.508A.505.505 0 008 3.507z"
  })));
};

export default IconAlarm;